/**
 * @module app.shared
 */

import { encodeQueryString } from 'app/shared/lib/utilities';
import { IApiQueryFilter, ApiQueryFilterGroup } from './api-filters';

export interface IQueryExistsFilterOptions {
    omitWhenEmpty: boolean;
}

export class ApiQueryExistsFilter implements IApiQueryFilter {
    //public options: ApiQueryExistsFilterOptions;
    constructor(public relationship: string, public predicate: ApiQueryFilterGroup | null) {}
    public toString(): string {
        const encodedRelationship = encodeQueryString(this.relationship);
        let filterArgument: string = '';

        if(this.predicate) {
            filterArgument = this.predicate.toString();
            if(filterArgument) {
                filterArgument = `,${filterArgument}`;
            }
        }
        return `exists(${encodedRelationship}${filterArgument})`;
    }
}
